module.exports = __webpack_public_path__ + "static/founder.wang-590acf6f40fe32556b054e3a76e69689.png";